import { checkWxSDKReady } from './util';

/**
 * 屏蔽分享
 */
export default function hideOptionMenu() {
    checkWxSDKReady(() => {
        WeixinJSBridge.invoke('hideOptionMenu');
    });
}
